module.exports = __webpack_public_path__ + "static/media/smiley-red.264b78ab.svg";